"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DeleteHighlightModal;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable react/jsx-props-no-spreading */

function DeleteHighlightModal(_ref) {
  var {
    handleClose,
    open,
    deleteHighlight
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_saraivaUi.Dialog, {
    title: "Excluir nota e destaque",
    open: open,
    secondaryButton: "Cancelar",
    primaryButton: "Excluir",
    handleClose: handleClose,
    handleConfirm: deleteHighlight
  }, "Deseja excluir esta nota e destaque?"));
}
DeleteHighlightModal.propTypes = {
  handleClose: _propTypes.default.func.isRequired,
  open: _propTypes.default.bool.isRequired,
  deleteHighlight: _propTypes.default.func.isRequired
};